import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { getWorkspacePath } from '../helpers/routes';
import { type WorkspacePayload, WorkspaceTypeID } from '../lib/api/workspaces/dto';

export const useWorkspaceNavigate = () => {
  const history = useHistory();

  const navigate = useCallback(
    (to: string, options?: { state?: Record<string, unknown> }) => {
      history.push(to, options?.state);
    },
    [history],
  );

  const navigateToWorkspace = useCallback(
    (workspace: WorkspacePayload, state?: Record<string, unknown>) => {
      const workspacePath = getWorkspacePath(workspace.workspace_id, workspace.workspace_type_id);
      navigate(workspacePath, { state });
    },
    [navigate],
  );

  const navigateToWorkspaceWithId = useCallback(
    (workspaceId: number, state?: Record<string, unknown>) => {
      navigate(getWorkspacePath(workspaceId, WorkspaceTypeID.HCPExplorer), { state });
    },
    [navigate],
  );

  const navigateToWorkspaceList = useCallback(() => {
    navigate('/workspaces');
  }, [navigate]);

  return {
    navigate,
    navigateToWorkspace,
    navigateToWorkspaceList,
    navigateToWorkspaceWithId,
  };
};
